export const endPoints = {
    GET_SMS_LICENSE: '/v1/sms-license',
    POST_SMS_LICENSE: '/v1/sms-license',
};
